import { useState } from "react";
import { ToolsShell, primaryBtn, TOOLS_ACCENT } from "./ToolsShell.jsx";
import { formatNum } from "../lib/formatNum.js";

// A phone screen ruler can't know its own physical DPI reliably across
// devices, so this is calibration-based: user matches the bar to a known
// object (credit card = 85.6mm wide, ISO/IEC 7810 ID-1), then the px/mm
// scale is solved and reused.
const CARD_MM = 85.6;

export default function Ruler() {
  const [calPx, setCalPx] = useState(320); // px length user sets to match card
  const [calibrated, setCalibrated] = useState(false);
  const pxPerMm = calPx / CARD_MM;

  return (
    <ToolsShell title="Screen Ruler">
      {!calibrated ? (
        <div>
          <p style={{ fontSize: 14, color: "#C8CADF", marginTop: 0 }}>
            Place a credit/ID card (standard 85.6 mm wide) against the screen and adjust the bar until it exactly matches the card's width.
          </p>
          <div style={{ height: 56, background: TOOLS_ACCENT, borderRadius: 8, width: calPx, maxWidth: "100%", margin: "24px 0", transition: "width 0.05s" }} />
          <input
            type="range"
            min="160"
            max={Math.min(420, typeof window !== "undefined" ? window.innerWidth - 40 : 360)}
            value={calPx}
            onChange={(e) => setCalPx(Number(e.target.value))}
            style={{ width: "100%", accentColor: TOOLS_ACCENT }}
          />
          <div style={{ fontSize: 13, color: "#9A9DBE", marginTop: 8 }}>
            {formatNum(pxPerMm, 2)} px/mm
          </div>
          <button onClick={() => setCalibrated(true)} style={{ ...primaryBtn, marginTop: 20, width: "100%" }}>
            Calibrated — show ruler
          </button>
        </div>
      ) : (
        <div>
          <RulerBar pxPerMm={pxPerMm} />
          <button onClick={() => setCalibrated(false)} style={{ marginTop: 18, background: "#1C1E2E", color: "#9A9DBE", border: "none", borderRadius: 8, padding: "10px 18px", fontSize: 13, cursor: "pointer" }}>
            Re-calibrate
          </button>
          <p style={{ fontSize: 12, color: "#5B5E7A", marginTop: 14 }}>
            Hold objects against the screen. Accuracy depends on your calibration — recalibrate per device.
          </p>
        </div>
      )}
    </ToolsShell>
  );
}

function RulerBar({ pxPerMm }) {
  const maxMm = typeof window !== "undefined" ? Math.floor((window.innerHeight - 240) / pxPerMm) : 120;
  const ticks = [];
  for (let mm = 0; mm <= maxMm; mm++) {
    const isCm = mm % 10 === 0;
    const isHalf = mm % 5 === 0;
    ticks.push(
      <div key={mm} style={{ position: "absolute", top: mm * pxPerMm, left: 0, height: 1, width: isCm ? 70 : isHalf ? 44 : 26, background: "#7C8099" }}>
        {isCm && (
          <span style={{ position: "absolute", left: 78, top: -8, fontSize: 13, color: TOOLS_ACCENT, fontWeight: 600 }}>
            {mm / 10} cm
          </span>
        )}
      </div>
    );
  }
  return (
    <div style={{ position: "relative", height: maxMm * pxPerMm + 20, borderLeft: `2px solid ${TOOLS_ACCENT}`, marginTop: 10 }}>
      {ticks}
    </div>
  );
}

